import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-long-term-icon',
  templateUrl: './long-term-icon.component.html',
  styles: []
})
export class LongTermIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
